
import Vue from "vue";
import i18n from './i18n'
import { extend, configure, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";

extend('required', required)
extend('email', email)
extend('min', min)

configure({
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`${field}`)

    return i18n.t(`validation.${values._rule_}`, values)
  }
})


Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);